import React, { useCallback, useContext, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Context from '../../context';
import { summaryApi } from '../../common';
import { authFetch } from '../../helpers/authFetch';

function StripeVerify() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const context = useContext(Context)
    const userData = useSelector((state) => state?.user?.user);
    
    const success = searchParams.get('success')
    const orderId = searchParams.get('orderId')

    const verifyPayment = useCallback (async () => {
        try {
            const response = await authFetch(summaryApi.stripeVerify.url, {
                method: summaryApi.stripeVerify.method,
                
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    orderId,
                    success,
                    userId: userData?._id
                })
            })
            
            const responseData = await response.json();
            
            if (responseData.success) {
                context.fetchUserAddToCart([])
                navigate('/orders')
                toast.success('Payment successful')
            } else {
                toast.error(responseData.message || 'Payment verification failed')
                navigate('/cart')
            }
        } catch (error) {
            console.error(error)
            toast.error(error.message)
            navigate('/cart')
        }
    }, [orderId, success, userData, context, navigate])

    useEffect(() => {
        if (orderId && success) {
            verifyPayment()
        }
    }, [orderId, success, verifyPayment])

    return (
        <div className="flex justify-center items-center h-screen">
            <div className="text-center">
                <p className="text-xl">Verifying payment...</p>
            </div>
        </div>
    )
}

export default StripeVerify